/**
 * "O cockpit foi atualizado" — a faixa que aparece quando a aba ficou com a versão velha
 * depois de um deploy (`useVersaoNova`, 07/10). Não recarrega sozinha: quem está no meio de
 * uma conferência ou de uma pergunta ao agente decide a hora. Um botão, uma frase.
 */
import { useVersaoNova } from "../ganchos/useVersaoNova";

export function AvisoDeVersao({ ativo }: { ativo?: boolean }) {
  const nova = useVersaoNova(ativo === undefined ? {} : { ativo });
  if (!nova) return null;
  return (
    <div
      role="status"
      className="flex flex-wrap items-center gap-2 rounded-cartao border border-amarelo-borda bg-amarelo-fundo px-3 py-2 text-[12px] text-amarelo"
    >
      <span className="min-w-0 flex-1">
        O cockpit foi atualizado. Recarregue para usar a versão nova — o que
        está aberto continua funcionando até lá.
      </span>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="min-h-8 shrink-0 rounded-botao border border-amarelo-borda px-2.5 text-[11.5px] font-semibold hover:bg-realce"
      >
        Recarregar
      </button>
    </div>
  );
}
